<template>
  <div class="main-container">
    <p v-if="familyError" role="alert" class="error-message">{{ familyError }}</p>
    <go-back class="mb-3 px-3" @click="$router.push({ name: 'Index' })" />
    <div v-if="getAllBoughted.length > 0">
      <div class="row mb-5" v-for="menu in getAvaiableUserSubscribesBoughted" :key="menu.id">
        <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-8 cursor-pointer p-0 mb-3" @click="$router.push({ name: menu.isTest ? 'ReceipesTest' : 'ReceipesRegular', params: { id: menu.id } })">
          <subscribe :title="menu.title" :menuId="menu.id" :bought="checkSubscribeIsBought(menu)" single/>
        </div>
        <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-4" :class="{ 'mb-5': isMobile, 'p-0': $mq === 'lg' || $mq === 'md' }">
          <div class="k-family k-card h-100">
            <div class="k-family-header d-flex flex-column">
              <div class="k-family__title d-flex justify-content-between align-items-center w-100">
                <span class="d-flex align-items-center">
                  <span class="mr-2">Семья</span>
                  <span v-if="$mq === 'xs' || $mq === 'sm'">
                    <svg @click="menu.family_tip = true" v-if="!menu.family_tip" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 0C3.57841 0 0 3.578 0 8C0 12.4215 3.578 16 8 16C12.4216 16 16 12.422 16 8C16 3.57841 12.422 0 8 0ZM8 14.8837C4.20431 14.8837 1.11628 11.7957 1.11628 8C1.11628 4.20428 4.20431 1.11628 8 1.11628C11.7957 1.11628 14.8837 4.20428 14.8837 8C14.8837 11.7957 11.7957 14.8837 8 14.8837Z" fill="#808080"/>
                      <path d="M7.76345 10.126C7.32117 10.126 6.96313 10.4945 6.96313 10.9368C6.96313 11.3686 7.31063 11.7477 7.76345 11.7477C8.21626 11.7477 8.57426 11.3686 8.57426 10.9368C8.57426 10.4945 8.2057 10.126 7.76345 10.126Z" fill="#808080"/>
                      <path d="M7.90018 3.9834C6.47856 3.9834 5.82568 4.82587 5.82568 5.39449C5.82568 5.80518 6.17318 5.99474 6.4575 5.99474C7.02615 5.99474 6.7945 5.18387 7.86859 5.18387C8.39509 5.18387 8.81634 5.41555 8.81634 5.89996C8.81634 6.46859 8.22662 6.79502 7.87912 7.08987C7.57371 7.35309 7.17359 7.78487 7.17359 8.69049C7.17359 9.23806 7.32103 9.39602 7.75275 9.39602C8.26871 9.39602 8.37403 9.16437 8.37403 8.96424C8.37403 8.41668 8.38456 8.10077 8.96375 7.64796C9.24806 7.42684 10.1431 6.71074 10.1431 5.7209C10.1431 4.73105 9.24806 3.9834 7.90018 3.9834Z" fill="#808080"/>
                    </svg>
                    <svg @click="menu.family_tip = false" v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <circle cx="8" cy="8" r="8" fill="#F68C1E"/>
                      <path d="M7.7632 10.1406C7.32092 10.1406 6.96289 10.5092 6.96289 10.9514C6.96289 11.3832 7.31039 11.7623 7.7632 11.7623C8.21602 11.7623 8.57402 11.3832 8.57402 10.9514C8.57402 10.5092 8.20545 10.1406 7.7632 10.1406Z" fill="white"/>
                      <path d="M7.89969 4C6.47807 4 5.8252 4.84247 5.8252 5.41109C5.8252 5.82178 6.1727 6.01134 6.45701 6.01134C7.02566 6.01134 6.79401 5.20047 7.8681 5.20047C8.3946 5.20047 8.81585 5.43216 8.81585 5.91656C8.81585 6.48519 8.22613 6.81163 7.87863 7.10647C7.57323 7.36969 7.1731 7.80147 7.1731 8.70709C7.1731 9.25466 7.32054 9.41263 7.75226 9.41263C8.26823 9.41263 8.37354 9.18097 8.37354 8.98084C8.37354 8.43328 8.38407 8.11737 8.96326 7.66456C9.24757 7.44344 10.1426 6.72734 10.1426 5.7375C10.1426 4.74766 9.24757 4 7.89969 4Z" fill="white"/>
                    </svg>
                  </span>
                  <adaptive-propper width="400" autobox v-else>
                    <template #element="{ active }">
                      <svg v-if="!active" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 0C3.57841 0 0 3.578 0 8C0 12.4215 3.578 16 8 16C12.4216 16 16 12.422 16 8C16 3.57841 12.422 0 8 0ZM8 14.8837C4.20431 14.8837 1.11628 11.7957 1.11628 8C1.11628 4.20428 4.20431 1.11628 8 1.11628C11.7957 1.11628 14.8837 4.20428 14.8837 8C14.8837 11.7957 11.7957 14.8837 8 14.8837Z" fill="#808080"/>
                        <path d="M7.76345 10.126C7.32117 10.126 6.96313 10.4945 6.96313 10.9368C6.96313 11.3686 7.31063 11.7477 7.76345 11.7477C8.21626 11.7477 8.57426 11.3686 8.57426 10.9368C8.57426 10.4945 8.2057 10.126 7.76345 10.126Z" fill="#808080"/>
                        <path d="M7.90018 3.9834C6.47856 3.9834 5.82568 4.82587 5.82568 5.39449C5.82568 5.80518 6.17318 5.99474 6.4575 5.99474C7.02615 5.99474 6.7945 5.18387 7.86859 5.18387C8.39509 5.18387 8.81634 5.41555 8.81634 5.89996C8.81634 6.46859 8.22662 6.79502 7.87912 7.08987C7.57371 7.35309 7.17359 7.78487 7.17359 8.69049C7.17359 9.23806 7.32103 9.39602 7.75275 9.39602C8.26871 9.39602 8.37403 9.16437 8.37403 8.96424C8.37403 8.41668 8.38456 8.10077 8.96375 7.64796C9.24806 7.42684 10.1431 6.71074 10.1431 5.7209C10.1431 4.73105 9.24806 3.9834 7.90018 3.9834Z" fill="#808080"/>
                      </svg>
                      <svg v-else width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="8" cy="8" r="8" fill="#F68C1E"/>
                        <path d="M7.7632 10.1406C7.32092 10.1406 6.96289 10.5092 6.96289 10.9514C6.96289 11.3832 7.31039 11.7623 7.7632 11.7623C8.21602 11.7623 8.57402 11.3832 8.57402 10.9514C8.57402 10.5092 8.20545 10.1406 7.7632 10.1406Z" fill="white"/>
                        <path d="M7.89969 4C6.47807 4 5.8252 4.84247 5.8252 5.41109C5.8252 5.82178 6.1727 6.01134 6.45701 6.01134C7.02566 6.01134 6.79401 5.20047 7.8681 5.20047C8.3946 5.20047 8.81585 5.43216 8.81585 5.91656C8.81585 6.48519 8.22613 6.81163 7.87863 7.10647C7.57323 7.36969 7.1731 7.80147 7.1731 8.70709C7.1731 9.25466 7.32054 9.41263 7.75226 9.41263C8.26823 9.41263 8.37354 9.18097 8.37354 8.98084C8.37354 8.43328 8.38407 8.11737 8.96326 7.66456C9.24757 7.44344 10.1426 6.72734 10.1426 5.7375C10.1426 4.74766 9.24757 4 7.89969 4Z" fill="white"/>
                      </svg>
                    </template>
                    <template #content>
                      <div class="mt-2" style="max-width: 300px">
                        <div class="k-recipe__warning-text">
                          <p>Настраивайте приемы пищи, которые регулярно будут есть члены Вашей семьи. Выделить цветом - выбрать, снять выделение - отменить выбор</p>
                        </div>
                      </div>
                    </template>
                  </adaptive-propper>
                </span>
                <span class="cursor-pointer" v-if="checkSubscribeIsBought(menu)">
                  <adaptive-propper height="200" description="Чтобы создать нового члена семьи, перейдите в настройки Профиля" :buttonCallback="goToProfile">
                    <template #element>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.6448 6.60794L13.8095 6.15659C13.6992 5.80869 13.5573 5.47131 13.3861 5.14859C13.6616 4.68991 14.2407 3.7245 14.2407 3.7245C14.3515 3.54003 14.3222 3.30381 14.1702 3.15184L12.8445 1.82616C12.6926 1.67372 12.4568 1.64444 12.2719 1.75566L10.8455 2.61031C10.5246 2.44047 10.189 2.29994 9.84344 2.19053L9.39209 0.35525C9.33988 0.1465 9.15266 0 8.9375 0H7.0625C6.84734 0 6.65966 0.1465 6.60794 0.355219C6.60794 0.355219 6.29528 1.63616 6.15703 2.19006C5.78853 2.30678 5.43241 2.45831 5.09319 2.64325L3.61416 1.75566C3.42922 1.64578 3.19394 1.67419 3.0415 1.82616L1.71581 3.15184C1.56384 3.30381 1.53453 3.54003 1.64531 3.7245L2.55994 5.25206C2.41253 5.54275 2.28894 5.84531 2.19053 6.15522L0.35525 6.60794C0.1465 6.66012 0 6.84734 0 7.0625V8.9375C0 9.15266 0.1465 9.34034 0.355219 9.39206L2.19097 9.84341C2.30222 10.1963 2.44684 10.5392 2.62219 10.8683L1.80372 12.2325C1.69294 12.4169 1.72225 12.6532 1.87422 12.8051L3.19991 14.1308C3.35144 14.2823 3.58763 14.3112 3.77256 14.2013C3.77256 14.2013 4.69038 13.6511 5.13991 13.3819C5.46537 13.5554 5.80594 13.6987 6.15706 13.8099L6.60797 15.6447C6.65966 15.8535 6.84734 16 7.0625 16H8.9375C9.15266 16 9.33987 15.8535 9.39206 15.6448L9.84297 13.8099C10.2042 13.6955 10.552 13.5476 10.883 13.3682C11.3449 13.6451 12.2718 14.2013 12.2718 14.2013C12.4563 14.3116 12.6925 14.2832 12.8445 14.1308L14.1702 12.8051C14.3222 12.6532 14.3515 12.4169 14.2407 12.2325L13.3979 10.8285C13.5641 10.5131 13.7019 10.1831 13.8095 9.84341L15.6447 9.39206C15.8535 9.33987 16 9.15266 16 8.9375V7.0625C16 6.84734 15.8535 6.66012 15.6448 6.60794ZM8 11.2812C6.19091 11.2812 4.71875 9.80909 4.71875 8C4.71875 6.19091 6.19091 4.71875 8 4.71875C9.80909 4.71875 11.2812 6.19091 11.2812 8C11.2812 9.80909 9.80909 11.2812 8 11.2812Z"
                          fill="#646465"
                        />
                      </svg>
                    </template>
                    <template #content>
                      <div class="d-flex flex-column">
                        <div class="loading-indication" v-if="modalBusy">
                          <k-spinner low/>
                        </div>
                        <div
                          v-for="member in getUserFamily"
                          :key="member.id"
                          class="d-flex align-items-center justify-content-between w-100 mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <img
                              v-if="member.avatar_url"
                              class="k-family__member-avatar"
                              :src="member.avatar_url"
                              alt="avatar"
                            />
                            <div
                              v-else
                              class="k-family__member-avatar k-family__member-no-avatar"
                            >{{ member.name[0] }}</div>
                            <span>{{ member.name }}</span>
                          </div>
                          <div
                            class="k-recipe__check-badge d-flex k-badge-orange-light"
                            v-if="!isInBoughtedMenuProfiles(menu, member.id)"
                            @click="addToMenu(member, getBoughtedMenu(menu))"
                          >
                            <span>
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="mr-2"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z"
                                  fill="#F68C1E"
                                />
                              </svg>
                            </span>
                            <span>Добавить</span>
                          </div>
                          <div
                            class="k-recipe__check-badge d-flex k-badge-red-light"
                            v-else
                            @click="removeFromMenu(member, menu)"
                          >
                            <span>
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="mr-2"
                              >
                                <path
                                  d="M10.6786 1.84615H7.89286V1.38462C7.89286 0.621087 7.26807 0 6.5 0H4.64286C3.87478 0 3.25 0.621087 3.25 1.38462V1.84615H0.464286C0.207652 1.84615 0 2.05281 0 2.30769C0 2.56258 0.207652 2.76923 0.464286 2.76923H0.928571V9.69231C0.928571 10.9647 1.97005 12 3.25 12H7.89286C9.17281 12 10.2143 10.9647 10.2143 9.69231V2.76923H10.6786C10.9352 2.76923 11.1429 2.56258 11.1429 2.30769C11.1429 2.05281 10.9352 1.84615 10.6786 1.84615ZM4.17857 1.38462C4.17857 1.13019 4.38669 0.923077 4.64286 0.923077H6.5C6.75617 0.923077 6.96429 1.13019 6.96429 1.38462V1.84615H4.17857V1.38462ZM9.28572 9.69231C9.28572 10.4558 8.66093 11.0769 7.89286 11.0769H3.25C2.48193 11.0769 1.85714 10.4558 1.85714 9.69231V2.76923H9.28572V9.69231ZM5.10714 8.76923V5.07692C5.10714 4.82204 5.3148 4.61538 5.57143 4.61538C5.82806 4.61538 6.03571 4.82204 6.03571 5.07692V8.76923C6.03571 9.02412 5.82806 9.23077 5.57143 9.23077C5.3148 9.23077 5.10714 9.02412 5.10714 8.76923ZM3.25 8.76923V5.07692C3.25 4.82204 3.45765 4.61538 3.71429 4.61538C3.97092 4.61538 4.17857 4.82204 4.17857 5.07692V8.76923C4.17857 9.02412 3.97092 9.23077 3.71429 9.23077C3.45765 9.23077 3.25 9.02412 3.25 8.76923ZM6.96429 8.76923V5.07692C6.96429 4.82204 7.17194 4.61538 7.42857 4.61538C7.68521 4.61538 7.89286 4.82204 7.89286 5.07692V8.76923C7.89286 9.02412 7.68521 9.23077 7.42857 9.23077C7.17194 9.23077 6.96429 9.02412 6.96429 8.76923Z"
                                  fill="#D51E3A"
                                />
                              </svg>
                            </span>
                            <span>Удалить</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </adaptive-propper>
                </span>
              </div>
              <div v-if="menu.family_tip" class="k-recipe__warning k-recipe__warning--orange col-12 k-recipe__card k-recipe__card--default k-recipe__card--fluid-height mt-2">
                <div class="k-recipe__warning-text">
                  <p>Настраивайте приемы пищи, которые регулярно будут есть члены Вашей семьи. Выделить цветом - выбрать, снять выделение - отменить выбор.</p>
                </div>
              </div>
            </div>
            <div
              class="k-family__members k-family__members--fullsize"
              v-if="checkSubscribeIsBought(menu) && getBoughtedMenuProfiles(menu).length > 0"
            >
              <div class="loading-indication" v-if="busy">
                <k-spinner />
              </div>
              <div
                class="k-family__member"
                v-for="member in getBoughtedMenuProfiles(menu)"
                :key="member.id"
              >
                <img
                  v-if="member.avatar_url"
                  class="k-family__member-avatar"
                  :src="member.avatar_url"
                  alt="avatar"
                />
                <div
                  v-else
                  class="k-family__member-avatar k-family__member-no-avatar"
                >{{ member.name[0] }}</div>
                <div class="k-family__member-name">{{ member.name }}</div>
                <div class="k-family__badges">
                  <div class="k-article__badges">
                    <span
                      v-if="avaiableMealTypeInMenu(menu, 'breakfast')"
                      class="k-badge badge k-badge-yellow cursor-pointer mx-1"
                      :class="{ outlined: !checkMealType(member, 'breakfast') }"
                      @click="makeEditUserInMenu(member, getBoughtedMenu(menu), 'breakfast', menu)"
                    >Завтрак</span>
                    <span
                      v-if="avaiableMealTypeInMenu(menu, 'lunch')"
                      class="k-badge badge k-badge-orange-dark cursor-pointer mx-1"
                      :class="{ outlined: !checkMealType(member, 'lunch') }"
                      @click="makeEditUserInMenu(member, getBoughtedMenu(menu), 'lunch', menu)"
                    >Обед</span>
                    <span
                      v-if="avaiableMealTypeInMenu(menu, 'brunch')"
                      class="k-badge badge k-badge-orange-dark cursor-pointer mx-1"
                      :class="{ outlined: !checkMealType(member, 'brunch') }"
                      @click="makeEditUserInMenu(member, getBoughtedMenu(menu), 'brunch', menu)"
                    >Перекус</span>
                    <span
                      v-if="avaiableMealTypeInMenu(menu, 'dinner')"
                      class="k-badge badge k-badge-red cursor-pointer mx-1"
                      :class="{ outlined: !checkMealType(member, 'dinner') }"
                      @click="makeEditUserInMenu(member, getBoughtedMenu(menu), 'dinner', menu)"
                    >Ужин</span>
                  </div>
                </div>
              </div>
            </div>
            <div
              v-else-if="checkSubscribeIsBought(menu) && !getBoughtedMenuProfiles(menu).length"
              class="k-subscribes__buy-empty-family-wrapper"
            >
              <p
                class="k-subscribes__no-buy-family-title k-subscribes__no-buy-family-title--bold mb-2"
              >Никто не ест</p>
              <p
                class="k-subscribes__no-buy-family-title"
              >Нужно указать всех членов семьи, которые будут питаться по этому меню</p>
              <adaptive-propper height="200" :ref="`popper-${menu.id}`" description="Чтобы создать нового члена семьи, перейдите в настройки Профиля" :buttonCallback="goToProfile">
                <template #element>
                  <div class="k-recipe__button px-4 my-2 d-flex">Добавить</div>
                </template>
                <template #content>
                  <div class="d-flex flex-column">
                    <div class="loading-indication" v-if="modalBusy">
                      <k-spinner low />
                    </div>
                    <div
                      v-for="member in getUserFamily"
                      :key="member.id"
                      class="d-flex align-items-center justify-content-between w-100 mb-2"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          v-if="member.avatar_url"
                          class="k-family__member-avatar"
                          :src="member.avatar_url"
                          alt="avatar"
                        />
                        <div
                          v-else
                          class="k-family__member-avatar k-family__member-no-avatar"
                        >{{ member.name[0] }}</div>
                        <span>{{ member.name }}</span>
                      </div>
                      <div
                        class="k-recipe__check-badge d-flex k-badge-orange-light"
                        v-if="!isInBoughtedMenuProfiles(menu, member.id)"
                        @click="addToMenu(member, getBoughtedMenu(menu))"
                      >
                        <span>
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            class="mr-2"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z"
                              fill="#F68C1E"
                            />
                          </svg>
                        </span>
                        <span>Добавить</span>
                      </div>
                      <div
                        class="k-recipe__check-badge d-flex k-badge-red-light"
                        v-else
                        @click="removeFromMenu(member, menu)"
                      >
                        <span>
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                                class="mr-2"
                          >
                            <path
                              d="M10.6786 1.84615H7.89286V1.38462C7.89286 0.621087 7.26807 0 6.5 0H4.64286C3.87478 0 3.25 0.621087 3.25 1.38462V1.84615H0.464286C0.207652 1.84615 0 2.05281 0 2.30769C0 2.56258 0.207652 2.76923 0.464286 2.76923H0.928571V9.69231C0.928571 10.9647 1.97005 12 3.25 12H7.89286C9.17281 12 10.2143 10.9647 10.2143 9.69231V2.76923H10.6786C10.9352 2.76923 11.1429 2.56258 11.1429 2.30769C11.1429 2.05281 10.9352 1.84615 10.6786 1.84615ZM4.17857 1.38462C4.17857 1.13019 4.38669 0.923077 4.64286 0.923077H6.5C6.75617 0.923077 6.96429 1.13019 6.96429 1.38462V1.84615H4.17857V1.38462ZM9.28572 9.69231C9.28572 10.4558 8.66093 11.0769 7.89286 11.0769H3.25C2.48193 11.0769 1.85714 10.4558 1.85714 9.69231V2.76923H9.28572V9.69231ZM5.10714 8.76923V5.07692C5.10714 4.82204 5.3148 4.61538 5.57143 4.61538C5.82806 4.61538 6.03571 4.82204 6.03571 5.07692V8.76923C6.03571 9.02412 5.82806 9.23077 5.57143 9.23077C5.3148 9.23077 5.10714 9.02412 5.10714 8.76923ZM3.25 8.76923V5.07692C3.25 4.82204 3.45765 4.61538 3.71429 4.61538C3.97092 4.61538 4.17857 4.82204 4.17857 5.07692V8.76923C4.17857 9.02412 3.97092 9.23077 3.71429 9.23077C3.45765 9.23077 3.25 9.02412 3.25 8.76923ZM6.96429 8.76923V5.07692C6.96429 4.82204 7.17194 4.61538 7.42857 4.61538C7.68521 4.61538 7.89286 4.82204 7.89286 5.07692V8.76923C7.89286 9.02412 7.68521 9.23077 7.42857 9.23077C7.17194 9.23077 6.96429 9.02412 6.96429 8.76923Z"
                              fill="#D51E3A"
                            />
                          </svg>
                        </span>
                        <span>Удалить</span>
                      </div>
                    </div>
                  </div>
                </template>
              </adaptive-propper>
            </div>
            <div v-else class="k-subscribes__no-buy-family-wrapper">
              <p
                class="k-subscribes__no-buy-family-title"
              >Здесь будут отображаться все члены семьи, которые питаются по этому меню</p>
            </div>
            <!--/ .k-family-members -->
          </div>
        </div>
      </div>

      <div class="row mb-5" v-for="set in getAvaiableUserSetsBoughted" :key="set.id">
        <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-8 cursor-pointer p-0 mb-3" @click="openSet(set)">
          <subscribe
            :title="set.title"
            :menuId="set.id"
            single
            special
            :bought="checkSubscribeIsBought(set)"
          />
        </div>
        <div class="k-card-wrapper col-12 col-md-12 col-lg-12 col-xl-4" :class="{ 'mb-5': isMobile, 'p-0': $mq === 'lg' || $mq === 'md' }">
          <div class="k-family k-card h-100">
            <div class="k-family-header">
              <div class="k-family__title d-flex justify-content-between align-items-center w-100">
                <span>Семья</span>
                <span class="cursor-pointer" v-if="checkSubscribeIsBought(set)">
                  <adaptive-propper height="200" description="Чтобы создать нового члена семьи, перейдите в настройки Профиля" :buttonCallback="goToProfile">
                    <template #element>
                      <svg
                        width="16"
                        height="16"
                        viewBox="0 0 16 16"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.6448 6.60794L13.8095 6.15659C13.6992 5.80869 13.5573 5.47131 13.3861 5.14859C13.6616 4.68991 14.2407 3.7245 14.2407 3.7245C14.3515 3.54003 14.3222 3.30381 14.1702 3.15184L12.8445 1.82616C12.6926 1.67372 12.4568 1.64444 12.2719 1.75566L10.8455 2.61031C10.5246 2.44047 10.189 2.29994 9.84344 2.19053L9.39209 0.35525C9.33988 0.1465 9.15266 0 8.9375 0H7.0625C6.84734 0 6.65966 0.1465 6.60794 0.355219C6.60794 0.355219 6.29528 1.63616 6.15703 2.19006C5.78853 2.30678 5.43241 2.45831 5.09319 2.64325L3.61416 1.75566C3.42922 1.64578 3.19394 1.67419 3.0415 1.82616L1.71581 3.15184C1.56384 3.30381 1.53453 3.54003 1.64531 3.7245L2.55994 5.25206C2.41253 5.54275 2.28894 5.84531 2.19053 6.15522L0.35525 6.60794C0.1465 6.66012 0 6.84734 0 7.0625V8.9375C0 9.15266 0.1465 9.34034 0.355219 9.39206L2.19097 9.84341C2.30222 10.1963 2.44684 10.5392 2.62219 10.8683L1.80372 12.2325C1.69294 12.4169 1.72225 12.6532 1.87422 12.8051L3.19991 14.1308C3.35144 14.2823 3.58763 14.3112 3.77256 14.2013C3.77256 14.2013 4.69038 13.6511 5.13991 13.3819C5.46537 13.5554 5.80594 13.6987 6.15706 13.8099L6.60797 15.6447C6.65966 15.8535 6.84734 16 7.0625 16H8.9375C9.15266 16 9.33987 15.8535 9.39206 15.6448L9.84297 13.8099C10.2042 13.6955 10.552 13.5476 10.883 13.3682C11.3449 13.6451 12.2718 14.2013 12.2718 14.2013C12.4563 14.3116 12.6925 14.2832 12.8445 14.1308L14.1702 12.8051C14.3222 12.6532 14.3515 12.4169 14.2407 12.2325L13.3979 10.8285C13.5641 10.5131 13.7019 10.1831 13.8095 9.84341L15.6447 9.39206C15.8535 9.33987 16 9.15266 16 8.9375V7.0625C16 6.84734 15.8535 6.66012 15.6448 6.60794ZM8 11.2812C6.19091 11.2812 4.71875 9.80909 4.71875 8C4.71875 6.19091 6.19091 4.71875 8 4.71875C9.80909 4.71875 11.2812 6.19091 11.2812 8C11.2812 9.80909 9.80909 11.2812 8 11.2812Z"
                          fill="#646465"
                        />
                      </svg>
                    </template>
                    <template #content>
                      <div class="d-flex flex-column">
                        <div class="loading-indication" v-if="modalBusy">
                          <k-spinner low/>
                        </div>
                        <div
                          v-for="member in getUserFamily"
                          :key="member.id"
                          class="d-flex align-items-center justify-content-between w-100 mb-2"
                        >
                          <div class="d-flex align-items-center">
                            <img
                              v-if="member.avatar_url"
                              class="k-family__member-avatar"
                              :src="member.avatar_url"
                              alt="avatar"
                            />
                            <div
                              v-else
                              class="k-family__member-avatar k-family__member-no-avatar"
                            >{{ member.name[0] }}</div>
                            <span>{{ member.name }}</span>
                          </div>
                          <div
                            class="k-recipe__check-badge d-flex k-badge-orange-light"
                            v-if="!isInBoughtedSetProfiles(set, member.id)"
                            @click="addToSet(getBoughtedSet(set).recipe_set_id, member.id)"
                          >
                            <span>
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="mr-2"
                              >
                                <path
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z"
                                  fill="#F68C1E"
                                />
                              </svg>
                            </span>
                            <span>Добавить</span>
                          </div>
                          <div
                            class="k-recipe__check-badge d-flex k-badge-red-light"
                            v-else
                            @click="removeFromSet(member, set)"
                          >
                            <span>
                              <svg
                                width="12"
                                height="12"
                                viewBox="0 0 12 12"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                                class="mr-2"
                              >
                                <path
                                  d="M10.6786 1.84615H7.89286V1.38462C7.89286 0.621087 7.26807 0 6.5 0H4.64286C3.87478 0 3.25 0.621087 3.25 1.38462V1.84615H0.464286C0.207652 1.84615 0 2.05281 0 2.30769C0 2.56258 0.207652 2.76923 0.464286 2.76923H0.928571V9.69231C0.928571 10.9647 1.97005 12 3.25 12H7.89286C9.17281 12 10.2143 10.9647 10.2143 9.69231V2.76923H10.6786C10.9352 2.76923 11.1429 2.56258 11.1429 2.30769C11.1429 2.05281 10.9352 1.84615 10.6786 1.84615ZM4.17857 1.38462C4.17857 1.13019 4.38669 0.923077 4.64286 0.923077H6.5C6.75617 0.923077 6.96429 1.13019 6.96429 1.38462V1.84615H4.17857V1.38462ZM9.28572 9.69231C9.28572 10.4558 8.66093 11.0769 7.89286 11.0769H3.25C2.48193 11.0769 1.85714 10.4558 1.85714 9.69231V2.76923H9.28572V9.69231ZM5.10714 8.76923V5.07692C5.10714 4.82204 5.3148 4.61538 5.57143 4.61538C5.82806 4.61538 6.03571 4.82204 6.03571 5.07692V8.76923C6.03571 9.02412 5.82806 9.23077 5.57143 9.23077C5.3148 9.23077 5.10714 9.02412 5.10714 8.76923ZM3.25 8.76923V5.07692C3.25 4.82204 3.45765 4.61538 3.71429 4.61538C3.97092 4.61538 4.17857 4.82204 4.17857 5.07692V8.76923C4.17857 9.02412 3.97092 9.23077 3.71429 9.23077C3.45765 9.23077 3.25 9.02412 3.25 8.76923ZM6.96429 8.76923V5.07692C6.96429 4.82204 7.17194 4.61538 7.42857 4.61538C7.68521 4.61538 7.89286 4.82204 7.89286 5.07692V8.76923C7.89286 9.02412 7.68521 9.23077 7.42857 9.23077C7.17194 9.23077 6.96429 9.02412 6.96429 8.76923Z"
                                  fill="#D51E3A"
                                />
                              </svg>
                            </span>
                            <span>Удалить</span>
                          </div>
                        </div>
                      </div>
                    </template>
                  </adaptive-propper>
                </span>
              </div>
            </div>
            <div
              class="k-family__members"
              v-if="checkSubscribeIsBought(set) && getBoughtedSetProfiles(set).length > 0"
            >
              <div class="k-family__member" v-for="member in getBoughtedSetProfiles(set)" :key="member.id">
                <img
                  v-if="member.avatar_url"
                  class="k-family__member-avatar"
                  :src="member.avatar_url"
                  alt="avatar"
                />
                <div
                  v-else
                  class="k-family__member-avatar k-family__member-no-avatar"
                >{{ member.name[0] }}</div>
                <div class="k-family__member-name">{{ member.name }}</div>
              </div>
            </div>
            <div
              v-else-if="checkSubscribeIsBought(set) && !getBoughtedSetProfiles(set).length"
              class="k-subscribes__buy-empty-family-wrapper"
            >
              <p
                class="k-subscribes__no-buy-family-title k-subscribes__no-buy-family-title--bold mb-2"
              >Никто не ест</p>
              <p
                class="k-subscribes__no-buy-family-title"
              >Нужно указать всех членов семьи, которые будут питаться по этому меню</p>
              <adaptive-propper height="200" description="Чтобы создать нового члена семьи, перейдите в настройки Профиля" :buttonCallback="goToProfile">
                <template #element>
                  <div class="k-recipe__button px-4 my-2 d-flex">Добавить</div>
                </template>
                <template #content>
                  <div class="d-flex flex-column">
                    <div class="loading-indication" v-if="modalBusy">
                      <k-spinner low/>
                    </div>
                    <div
                      v-for="member in getUserFamily"
                      :key="member.id"
                      class="d-flex align-items-center justify-content-between w-100 mb-2"
                    >
                      <div class="d-flex align-items-center">
                        <img
                          v-if="member.avatar_url"
                          class="k-family__member-avatar"
                          :src="member.avatar_url"
                          alt="avatar"
                        />
                        <div
                          v-else
                          class="k-family__member-avatar k-family__member-no-avatar"
                        >{{ member.name[0] }}</div>
                        <span>{{ member.name }}</span>
                      </div>
                      <div
                        class="k-recipe__check-badge d-flex k-badge-orange-light"
                        v-if="!isInBoughtedSetProfiles(set, member.id)"
                        @click="addToSet(getBoughtedSet(set).recipe_set_id, member.id)"
                      >
                        <span>
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                                class="mr-2"
                          >
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M6 0C6.41421 0 6.75 0.335786 6.75 0.75V5.25H11.25C11.6642 5.25 12 5.58579 12 6C12 6.41421 11.6642 6.75 11.25 6.75H6.75V11.25C6.75 11.6642 6.41421 12 6 12C5.58579 12 5.25 11.6642 5.25 11.25V6.75H0.75C0.335786 6.75 0 6.41421 0 6C0 5.58579 0.335786 5.25 0.75 5.25H5.25V0.75C5.25 0.335786 5.58579 0 6 0Z"
                              fill="#F68C1E"
                            />
                          </svg>
                        </span>
                        <span>Добавить</span>
                      </div>
                      <div
                        class="k-recipe__check-badge d-flex k-badge-red-light"
                        v-else
                        @click="removeFromSet(member, set)"
                      >
                        <span>
                          <svg
                            width="12"
                            height="12"
                            viewBox="0 0 12 12"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                                class="mr-2"
                          >
                            <path
                              d="M10.6786 1.84615H7.89286V1.38462C7.89286 0.621087 7.26807 0 6.5 0H4.64286C3.87478 0 3.25 0.621087 3.25 1.38462V1.84615H0.464286C0.207652 1.84615 0 2.05281 0 2.30769C0 2.56258 0.207652 2.76923 0.464286 2.76923H0.928571V9.69231C0.928571 10.9647 1.97005 12 3.25 12H7.89286C9.17281 12 10.2143 10.9647 10.2143 9.69231V2.76923H10.6786C10.9352 2.76923 11.1429 2.56258 11.1429 2.30769C11.1429 2.05281 10.9352 1.84615 10.6786 1.84615ZM4.17857 1.38462C4.17857 1.13019 4.38669 0.923077 4.64286 0.923077H6.5C6.75617 0.923077 6.96429 1.13019 6.96429 1.38462V1.84615H4.17857V1.38462ZM9.28572 9.69231C9.28572 10.4558 8.66093 11.0769 7.89286 11.0769H3.25C2.48193 11.0769 1.85714 10.4558 1.85714 9.69231V2.76923H9.28572V9.69231ZM5.10714 8.76923V5.07692C5.10714 4.82204 5.3148 4.61538 5.57143 4.61538C5.82806 4.61538 6.03571 4.82204 6.03571 5.07692V8.76923C6.03571 9.02412 5.82806 9.23077 5.57143 9.23077C5.3148 9.23077 5.10714 9.02412 5.10714 8.76923ZM3.25 8.76923V5.07692C3.25 4.82204 3.45765 4.61538 3.71429 4.61538C3.97092 4.61538 4.17857 4.82204 4.17857 5.07692V8.76923C4.17857 9.02412 3.97092 9.23077 3.71429 9.23077C3.45765 9.23077 3.25 9.02412 3.25 8.76923ZM6.96429 8.76923V5.07692C6.96429 4.82204 7.17194 4.61538 7.42857 4.61538C7.68521 4.61538 7.89286 4.82204 7.89286 5.07692V8.76923C7.89286 9.02412 7.68521 9.23077 7.42857 9.23077C7.17194 9.23077 6.96429 9.02412 6.96429 8.76923Z"
                              fill="#D51E3A"
                            />
                          </svg>
                        </span>
                        <span>Удалить</span>
                      </div>
                    </div>
                  </div>
                </template>
              </adaptive-propper>
            </div>
            <div v-else class="k-subscribes__no-buy-family-wrapper">
              <p
                class="k-subscribes__no-buy-family-title"
              >Здесь будут отображаться все члены семьи, которые питаются по этому меню</p>
            </div>
            <!--/ .k-family-members -->
          </div>
        </div>
      </div>
    </div>
    <div v-else class="soon-wrapper">
      <p>Нет доступных меню</p>
    </div>
  </div>
</template>

<script>
import Subscribe from "../components/TheSubscribe";
import GoBack from "../components/TheGoBack";
import { mapGetters, mapActions, mapMutations } from "vuex";
import AdaptivePropper from "../components/TheAdaptivePropper.vue";
import KSpinner from '../components/TheSpinner';

import {
  addUserToMenu,
  removeUserFromMenu,
  addUserToSet,
  removeUserFromSet,
  editUserInMenu
} from "../api/SubscribeApi";

export default {
  components: {
    GoBack,
    Subscribe,
    AdaptivePropper,
    KSpinner
  },
  data: () => ({
    busy: false,
    modalBusy: false,
    familyError: "",
  }),
  computed: {
    ...mapGetters([
      "getUserFamily",
      "getUser",
      "getUserSevenDaysLeft",

      "getAvaiableUserSets",
      "getAvaiableUserSubscribes",

      "getUserSets",
      "getUserSubscribes",

      "getRecipeSets",
    ]),
    isMobile() {
      return this.$mq === 'sm' || this.$mq === 'md'
    },
    getAvaiableUserSubscribesBoughted() {
      return this.getAvaiableUserSubscribes
        .filter(el => this.getUserSubscribes.some(e => e.menu_id === el.id && e.is_paid === 't'))
        .filter(el => {
          // Убираем пробное на 7 дней
          return !(this.getUserSevenDaysLeft && el.id === 'ede8dfc0-6ef9-443b-bbf1-28aa6f67649b')
        })
        .map(el => {
          this.$set(el, 'family_tip', false);
          const testIds = ['ede8dfc0-6ef9-443b-bbf1-28aa6f67649b'];
          if (testIds.includes(el.id)) {
            this.$set(el, 'isTest', true);
          }
          return el;
        })
    },
    getAvaiableUserSetsBoughted() {
      return this.getAvaiableUserSets
        .filter(el => this.getUserSets.some(e => e.recipe_set_id === el.id && e.is_paid === 't'))
    },
    getAllBoughted() {
      return this.getAvaiableUserSubscribesBoughted.concat(this.getAvaiableUserSetsBoughted)
    }
  },
  methods: {
    ...mapActions([
      "loadUser",
    ]),
    ...mapMutations([
      'setProfileSubscriptionMeal',
    ]),
    goToProfile() {
      this.$router.push({ name: 'Profile' })
    },
    checkMealType(member, type) {
      return JSON.parse(member?.subscribe?.meal_types || "[]").some(
        el => el === type
      );
    },
    avaiableMealTypeInMenu(menu, type) {
      const currentSubscribe = this.getUserSubscribes.find(el => el.menu_id === menu.id)
      if (!currentSubscribe) return false;

      return currentSubscribe.meal_types.some(el => el === type)
    },
    async saveFamily(operation) {
      if (this.modalBusy) return;
      this.modalBusy = true;
      this.busy = true;
      this.familyError = "";
      try {
        const response = await operation();
        if (!response || !response.data || !response.data.success) throw new Error('SaveNotConfirmed');
        await this.loadUser({ force: true });
      } catch (error) {
        // Do not optimistically change selections before the API confirms them.
        this.familyError = "Не удалось подтвердить изменение семьи. Повторите действие.";
      } finally {
        this.modalBusy = false;
        this.busy = false;
      }
    },
    async makeEditUserInMenu(member, menu, type, clear_menu) {
      let meal_types = JSON.parse(member?.subscribe?.meal_types || '[]');
      meal_types = this.checkMealType(member, type) ? meal_types.filter(el => el !== type) : [...meal_types, type];
      const id = this.getBoughtedMenuProfileMealId(clear_menu, member.id);
      await this.saveFamily(() => editUserInMenu({ id }, { profile_id: member.id, subscription_id: menu.id, meal_types }));
    },
    async addToSet(recipe_set_id, profile_id) {
      await this.saveFamily(() => addUserToSet({ profile_id, recipe_set_id }));
    },
    async removeFromSet(member, set) {
      const id = this.getBoughtedSetProfileMealId(set, member.id);
      await this.saveFamily(() => removeUserFromSet({ id }));
    },
    async addToMenu(member, menu) {
      await this.saveFamily(() => addUserToMenu({ profile_id: member.id, subscription_id: menu.id, meal_types: menu.meal_types }));
    },
    async removeFromMenu(member, menu) {
      const id = this.getBoughtedMenuProfileMealId(menu, member.id);
      await this.saveFamily(() => removeUserFromMenu({ id }));
    },
    checkSubscribeIsBought({ id }) {
      return (
        this.getUserSubscribes.some(el => el.menu_id === id && el.is_paid === 't') ||
        this.getUserSets.some(el => el.recipe_set_id === id && el.is_paid === 't')
      );
    },
    getBoughtedMenuProfiles({ id }) {
      return (
        this.getUserSubscribes
          .find(el => el.menu_id === id)
          ?.profile_subscription_meals.map(el => {
            const user = this.getUserFamily.find(p => p.id === el.profile_id);
            return {
              ...user,
              subscribe: el,
              for_remove: !user,
            };
          })?.filter(el => !el.for_remove) || []
      );
    },
    isInBoughtedMenuProfiles({ id }, profile_id) {
      return this.getBoughtedMenuProfiles({ id }).find(
        el => el.id === profile_id
      );
    },
    getBoughtedMenuProfileMealId({ id }, profile_id) {
      return this.getBoughtedMenuProfiles({ id }).find(
        el => el.id === profile_id
      )?.subscribe.id;
    },
    getBoughtedMenu({ id }) {
      return this.getUserSubscribes.find(el => el.menu_id === id) || {};
    },
    getBoughtedSetProfiles({ id }) {
      return (
        this.getUserSets
          .find(el => el.recipe_set_id === id)
          ?.profile_recipe_sets.map(el => {
            const user = this.getUserFamily.find(p => p.id === el.profile_id);
            return {
              ...user,
              subscribe: el
            };
          }) || []
      );
    },
    getBoughtedSet({ id }) {
      return this.getUserSets.find(el => el.recipe_set_id === id) || {};
    },
    isInBoughtedSetProfiles({ id }, profile_id) {
      return this.getBoughtedSetProfiles({ id }).find(
        el => el.id === profile_id
      );
    },
    getBoughtedSetProfileMealId({ id }, profile_id) {
      return this.getBoughtedSetProfiles({ id }).find(
        el => el.id === profile_id
      )?.subscribe.id;
    },
    openSet(set) {
      const recipeSetType = this.getRecipeSets.find(el => el.id === set.id).recipeSetTypes[0];
      const viewNames = {
        special: 'ReceipesSpecial',
        partner: 'ReceipesSpecialPartner',
      };
      this.$router.push({
        name: viewNames[recipeSetType] || 'Index',
        params: {
          id: set.id
        }
      });
    },
  }
};
</script>

<style lang="scss">
.mobile-popover {
  .k-family__member-avatar,
  .k-family__member-no-avatar {
    font-size: 11px;
    width: 30px;
    height: 30px;
    margin-right: 10px;
    min-height: unset;
  }
}
</style>
<style lang="scss" scoped>
.k-subscribes__no-buy-family-title {
  font-style: normal;
  font-weight: normal;
  font-size: 17px;
  letter-spacing: -0.41px;
  color: #77767e;
  opacity: 0.6;
  text-align: center;
  margin: 0;

  &--bold {
    font-weight: bold;
    font-size: 22px;
  }
}
.k-subscribes__buy-empty-family-wrapper,
.k-subscribes__no-buy-family-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  width: 100%;
  padding: 0 40px;
}

.k-subscribes__buy-empty-family-wrapper {
  flex-direction: column;
}
</style>
